import { useState } from "react";
import axios from "axios";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "../config/api";

import { errorMessage } from "../utils/errorMessage";
export default function PolishNoteButton({
  rawNote,
  onPolished,
  matterRef = null,
  clientName = null,
  disabled = false,
  className = "",
}) {
  const [loading, setLoading] = useState(false);

  const handlePolish = async () => {
    if (!rawNote || rawNote.trim().length < 10) {
      toast.error("Note too short to polish — type at least 10 characters");
      return;
    }
    setLoading(true);
    try {
      const headers = {};
      const userId = sessionStorage.getItem("bonsai_user_id") || localStorage.getItem("bonsai_user_id");
      if (userId) headers["X-Bonsai-User-Id"] = userId;
      const res = await axios.post(
        `${API}/hub/ai/polish-note`,
        { raw_note: rawNote, matter_ref: matterRef, client_name: clientName },
        { headers }
      );
      const polished = res?.data?.polished_note || res?.data?.polished || res?.data?.result;
      if (!polished) throw new Error("No polished output returned");
      onPolished(polished);
      toast.success("Note polished");
    } catch (err) {
      toast.error(errorMessage(err, "Polish failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handlePolish}
      disabled={disabled || loading || !rawNote || rawNote.trim().length < 10}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md bg-teal/10 text-teal hover:bg-teal/20 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      data-testid="polish-note-btn"
      aria-label="Polish note"
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
      {loading ? "Polishing..." : "Polish"}
    </button>
  );
}
